export const labelStyle = { fontWeight: 'bold', color: '#90BA75', };
export const dataStyle = { textDecoration: 'underline', };
export const labelStyleSmall = { fontWeight: 'bold', color: '#90BA75', fontSize: '10px', };
export const dataStyleSmall = { textDecoration: 'underline', fontSize: '10px', };
export const boldStyle = { fontWeight: 'bold', };
export const dividerStyle = { color: '#90BA75', };
